import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Polyline, Tooltip, useMap } from "react-leaflet";
import L from "leaflet";
import { t } from "@/i18n";

const Fit = ({ geometry, pos }) => {
  const map = useMap();
  useEffect(() => {
    if (geometry?.length > 1) map.fitBounds(L.latLngBounds(geometry), { padding: [24, 24] });
    else if (pos) map.setView(pos, 10);
  }, [geometry, pos, map]);
  return null;
};

export const RouteStopsMap = ({ geometry, pos, items, kind, isActive }) => {
  const color = (p) => (kind === "promo" ? (isActive(p) ? "#ef0298" : "#f59e0b") : kind === "fuel" ? "#10b981" : "#f59e0b");
  const legend = [["#4accff", "La tua posizione", "dot"]];
  if (geometry) legend.push(["#4accff", "Percorso del viaggio", "line"]);
  if (kind === "promo") legend.push(["#ef0298", "Promozione disponibile ora", "dot"], ["#f59e0b", "Promozione in altri orari", "dot"]);
  else legend.push([color({}), kind === "fuel" ? "Stazione di servizio" : "Punto ristoro", "dot"]);
  return (
    <div className="space-y-2">
      <div className="h-64 sm:h-72 rounded-2xl overflow-hidden border border-[#243047]" data-testid="stops-map">
        <MapContainer center={pos} zoom={9} minZoom={2} maxBounds={[[-85, -180], [85, 180]]} maxBoundsViscosity={1} className="h-full w-full">
          <TileLayer url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap" className="nv-dark-tiles" noWrap />
          {geometry && <Polyline positions={geometry} pathOptions={{ color: "#4accff", weight: 6 }} />}
          <CircleMarker center={pos} radius={11} pathOptions={{ color: "#fff", fillColor: "#4accff", fillOpacity: 1, weight: 3 }} />
          {items.map((p) => (
            <CircleMarker key={p.id} center={[p.lat, p.lng]} radius={9} pathOptions={{ color: "#fff", fillColor: color(p), fillOpacity: 1, weight: 2 }}>
              <Tooltip>{p.place || p.name}</Tooltip>
            </CircleMarker>
          ))}
          <Fit geometry={geometry} pos={pos} />
        </MapContainer>
      </div>
      <div className="nv-card px-4 py-3 flex flex-wrap gap-x-5 gap-y-2 text-sm" data-testid="map-legend">
        <span className="nv-eyebrow self-center">{t("Legenda")}</span>
        {legend.map(([c, label, shape]) => (
          <span key={label} className="flex items-center gap-2">
            {shape === "line" ? <span className="h-1.5 w-6 rounded-full" style={{ background: c }} /> : <span className="h-4 w-4 rounded-full border-2 border-white" style={{ background: c }} />}
            {t(label)}
          </span>
        ))}
      </div>
    </div>
  );
};
